
/**
 * archivo de admin
 */

import { useState, useEffect } from 'react'
import url from '../api/url'
import { useEmpleadoStore } from '../stores/useEmpleadoStore'

export default function useSolicitudesSalida() {

    const [mes, setMes] = useState(`${new Date().getFullYear()}-${('0' + (new Date().getMonth() + 1)).slice(-2)}`)
    const [listaHistorial, setListaHistorial] = useState([])
    const { URL } = url()
    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const [cargando, setCargando] = useState(false)

    if (objLogueado.permitido !== "admin") {
        window.location = "/"
    }




    // funciones

    function traerHistorial() {

        if (!objLogueado.email) {
            return
        }

        setCargando(true)

        var body = new FormData()
        body.append('funcion', 'historialSalidasTotales')
        body.append('fecha', mes)

        fetch( URL, {
            method: 'post',
            body: body
        })
        .then(respuesta => respuesta.json())
        .then(datos => setListaHistorial(datos))
        .catch(err => alert('Hay problemas al traer tu historial de salidas.'))
        .finally(() => setCargando(false))
    }



    useEffect(() => {
        traerHistorial()
        // eslint-disable-next-line
    }, [mes])

    return {
        setMes, mes, listaHistorial, cargando
    }
}
